import type { SafeHtml } from '@angular/platform-browser';
import type { ChatBotData, ChatBotWidgetData } from '@web/widgets/chat-bot/type/chat-bot-widget.type';

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EButtonStyleType, EButtonType, ESize } from '@common/enums';
import { socialIconTemplates } from '@common/icons/social-icons';

import { WebBaseViewComponent } from '@web/widgets/common/abstract/web-base-view.component';
import {
    BUTTON_SIZE_CLASS_MAP,
    BUTTON_TYPE_CLASS_MAP,
    DEFAULT_BUTTON_CLASS,
} from '@web/widgets/common/base/base-button/base-button.const';
import { getSocialNetworkIconSrc } from '@web/shared/components/web-social-networks/utils';

import { getStyles } from './chat-bot-view.component.styles';

@Component({
    selector: 'web-chat-bot-view',
    templateUrl: './chat-bot-view.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
})
export class ChatBotViewComponent extends WebBaseViewComponent<ChatBotWidgetData> {
    public readonly EButtonType = EButtonType;

    protected getStyles = getStyles;

    public getStyleList(icon: ChatBotData): string {
        if (icon.type === EButtonType.icon) {
            return `${this.classes?.chatBotGroup}`;
        }

        const styles = `${DEFAULT_BUTTON_CLASS} ${BUTTON_SIZE_CLASS_MAP[this.widgetData.buttonSize ? this.widgetData.buttonSize : ESize.M]}`;
        if (this.chatBotStyleType === EButtonStyleType.custom) {
            return `${styles} ${this.classes?.chatBotGroup}`;
        }

        return `${styles} ${BUTTON_TYPE_CLASS_MAP[this.chatBotStyleType]} ${this.classes?.chatBotGroup}`;
    }

    public getIcon(iconName: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(socialIconTemplates[iconName]);
    }

    public getSocialNetworkIconSrcByChatBot(chatBot: ChatBotData): string {
        const folderName: string = chatBot.type === EButtonType.button ? 'full-white' : chatBot.iconType;
        return getSocialNetworkIconSrc(folderName, chatBot.socialNetwork);
    }

    public get chatBots(): ChatBotData[] {
        return this.widgetData.chatBots;
    }

    public get chatBotStyleType(): EButtonStyleType {
        return this.widgetData.styleType;
    }
}
